import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CartItem } from 'src/app/modules/cart-items/model/cart-items';


@Injectable({
  providedIn: 'root',
})
export class CartService {
  items: CartItem[] = [];
  private itemsSubject = new BehaviorSubject<any[]>([]);
  items$ = this.itemsSubject.asObservable();
  
  // Estado del modal del carrito
  private cartOpenSubject = new BehaviorSubject<boolean>(false);
  cartOpen$ = this.cartOpenSubject.asObservable();

  constructor() {
    const storedItems = localStorage.getItem('cart');
    if (storedItems) {
      const items = JSON.parse(storedItems);
      this.itemsSubject.next(items);
    }
  }

  addItem(product: any, quantity: number): void {
    const currentItems = this.itemsSubject.getValue();
    currentItems.push({ product, quantity });
    this.itemsSubject.next(currentItems);
    
    this.saveItems(currentItems);
  }

  clearCart(): void {
    this.itemsSubject.next([]);
    this.saveItems([]);
  }

  private saveItems(items: any[]): void {
    localStorage.setItem('cart', JSON.stringify(items));
  }
  getItems(): CartItem[] {
    const storedItems = localStorage.getItem('cart');
    if (storedItems) {
      const items = JSON.parse(storedItems);
      this.itemsSubject.next(items);
      return items;
    }
    return [];
  }

  // Métodos para controlar el modal
  openCart(): void {
    this.cartOpenSubject.next(true);
  }

  closeCart(): void {
    this.cartOpenSubject.next(false);
  }

  toggleCart(): void {
    this.cartOpenSubject.next(!this.cartOpenSubject.getValue());
  }
}



